import { useEffect } from "react";
import "./national-description.css";
import { FaStar, FaPhone } from "react-icons/fa";
import { useQuill } from "react-quilljs";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function NationalDescription({
  title, 
  description, 
  quoteBtn, 
  quoteProductID,
  contactSales,
  contactProductID,
}) {
  const [tNabvar] = useTranslation("navbar");
  const {quill, quillRef} = useQuill({
    readOnly: true,
    modules: {toolbar: false}
  });

  useEffect(() => {
    if(quill) {
      quill.setContents(description);
    }
  }, [description, quill]);

  return(
    <>
      <div className="description-content">
        <div className="title">
          <div className="icon"><FaStar /></div>
          <p>{title}</p>
        </div>

        <div className="description-text-content">
          <div className="description">
            <div className="quill-description">
              <div ref={quillRef}></div>
            </div>
          </div>

          <div className="btnsContainer">
            { quoteBtn !== undefined ? <Link id={quoteProductID} className="btn-quote" to={`/${quoteBtn.toLowerCase()}`}>{quoteBtn}</Link> : null }
            <Link id={contactProductID} className="btn-contact" to={`/${tNabvar("category-services.contact")}`}><span><FaPhone /></span>{contactSales}</Link>
          </div>

        </div>
      </div>
    </>
  )
}

export default NationalDescription;